import { ScreenNames } from "@swiggy-private/portal-dineout-context";
import { ROUTES } from "../constants";

export const getScreenName = (pathname: string) => {
    switch (pathname) {
        case ROUTES.MENU:
            return ScreenNames.MENU;
        case ROUTES.SEARCH:
            return ScreenNames.SEARCH;
        case ROUTES.COLLECTIONS:
            return ScreenNames.COLLECTION;
        default:
            return ScreenNames.MENU;
    }
};
